module.exports = __webpack_public_path__ + "static/media/shareBg.49994388.png";